import type { Point } from 'geojson';

export const isGeojsonPoint = (coordinate: any): coordinate is Point => {
  return (
    typeof coordinate === 'object' &&
    'type' in coordinate &&
    coordinate.type === 'Point' &&
    'coordinates' in coordinate
  );
};
